import React, { useState, useEffect, useRef } from 'react';
import styles from './AudioMessageCard.module.css';

import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import RatioAudioPlayer from '../RatioAudioPlayer/RatioAudioPlayer';
import { HiPlay, HiPause, HiArrowUp, HiArrowDown, HiPencil, HiMiniEye, HiMiniEyeSlash } from 'react-icons/hi2';
import Button from '../../ui/Button';

const colorPalette = [
  '#4ecdc4', // Aqua
  '#ff6b6b', // Coral Red
  '#52c41a', // Green
  '#ffb84a', // Light Gold
  '#8e44ad', // Purple
  '#1abc9c', // Teal
  '#3498db', // Sky Blue
  '#e67e22', // Orange
  '#e74c3c', // Bright Red
  '#2980b9', // Deep Blue
  '#27ae60', // Emerald
  '#c0392b', // Ruby
  '#16a085', // Jade
  '#2c3e50', // Navy
  '#f39c12', // Yellow Orange
  '#7f8c8d', // Silver Gray
  '#9b59b6', // Amethyst
  '#bdc3c7', // Cloudy Gray
  '#34495e'  // Graphite
];

const colorMap = {};

export function getOrAssignThreadColor(threadId) {
  if (!colorMap[threadId]) {
    const index = Object.keys(colorMap).length % colorPalette.length;
    colorMap[threadId] = colorPalette[index];
  }
  return colorMap[threadId];
}


export default function AudioMessageCard({
  audioUrl,
  msgid,
  replyto,
  threadid,
  senderName,
  user,
  timestamp,
  duration,
  transcript,
  score = 0,
  acceptable,
  isPlaying,
  onPlay,
  onReply,
  onPause,
  onPlayTread,
  onScore,
  onhandleAcceptance,
  editableTranscript = false,
  onTranscriptUpdate
}) {
  const [editing, setEditing] = useState(false);
  const [cuser, setUser] = useState(null);
  const [creplyuser, setReplyUser] = useState(null);
  const [editedTranscript, setEditedTranscript] = useState(transcript || '');
  const { userData, searchbyUsersId } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const displayId = msgid.slice(-5);
  
  const isOwnReply = replyto && replyto === user.uid;
  const threadColor = threadid != undefined ? getOrAssignThreadColor(threadid.toLowerCase()) : '#fca311';
 
  const handleTranscriptSubmit = () => {
    if (onTranscriptUpdate && editedTranscript !== transcript) {
      onTranscriptUpdate(editedTranscript);
    }
    setEditing(false);
  };

  useEffect(() => {
	  const startRound = async () => {
		const fuser = await searchbyUsersId(senderName);
		setUser(fuser[0]);
	  };
	   if(senderName != null && senderName != undefined) startRound();
  }, [senderName]);
  
  
  useEffect(() => {
	  const startRound = async () => {
		const fuser = await searchbyUsersId(replyto);
		setReplyUser(fuser[0]);
	  };
	  if(replyto != null && replyto != undefined) startRound();
  }, [replyto]);

  return (
    <div  title={displayId} className={`${styles.card} ${isPlaying ? styles.highlight : ''}`} style={threadColor ? { borderLeft: `4px solid ${threadColor}` } : {}}>
      <div className={styles.header}>
        {cuser != null && (<span className={styles.sender}>{cuser.username}</span>)}
        <span className={styles.time}>{new Date(timestamp).toLocaleString()}</span>
      </div>

      {cuser != null && creplyuser != null && creplyuser.username != cuser.username && (
        <div className={styles.replyLabel}  style={threadColor ? { color: `${threadColor}` } : {}}>
          Reply to {creplyuser.username} ({threadid})
        </div>
      )}

      <div className={styles.body}>
       {/* <button className={styles.playBtn} onClick={isPlaying ? onPause : onPlay}>
          {isPlaying ? <HiPause /> : <HiPlay />}
        </button>*/}
        {/*<audio src={audioUrl} onEnded={onPause} className={styles.audio} />*/}
		 <RatioAudioPlayer onEnded={onPause} onPlay={onPlay} onPause={onPause} audiodurationn={duration} src={audioUrl} />
        {/*<span className={styles.duration}>{duration}s</span>*/}
      </div>

      <div className={styles.footer}>
	    <div className={styles.footerbuttons}>
			<Button className={styles.replyBtn}
			  onClick={() => onReply(msgid, threadid != undefined && threadid != null ? threadid : displayId, senderName)}>
			  Reply
			</Button>
			{threadid != undefined && <Button className={styles.replyBtn}
			  onClick={() => onPlayTread(threadid != undefined && threadid != null ? threadid : '')}>
			  Show this Thread
			</Button>}
			{onhandleAcceptance && (
			  <div className={styles.acceptance}>
				{acceptable == 1 ? <Button onClick={() => onhandleAcceptance(0)}><HiMiniEye /></Button> :  <Button onClick={() => onhandleAcceptance(1)}><HiMiniEyeSlash /></Button>}
			  </div>
			)}
		</div>
		
		{onScore && (
          <div className={styles.scoring}>
            <Button onClick={() => onScore(1)}><HiArrowUp /></Button>
            <span>{score}</span>
            <Button onClick={() => onScore(-1)}><HiArrowDown /></Button>
          </div>
        )}

        {transcript?.length > 1 && !editing && (
          <div className={styles.transcript}>
            <div className={styles.transscriptheader} onClick={() => setIsOpen(prev => !prev)}>
              <strong>Transcript</strong>
              <span className={styles.chevron}>{isOpen ? '▲' : '▼'}</span>
            </div>

            {isOpen && (
              <div className={styles.transscriptcontent}>
                {transcript}

                {editableTranscript && (
                  <Button onClick={() => setEditing(true)} className={styles.editBtn}>
                    <HiPencil />
                  </Button>
                )}
              </div>
            )}
          </div>
        )}	


        {/*transcript?.length > 1 && !editing && (
          <div className={styles.transcript}>
            <strong>Transcript:</strong> {transcript}
            {editableTranscript && (
              <Button onClick={() => setEditing(true)} className={styles.editBtn}>
                <HiPencil />
              </Button>
            )}
          </div>
        )*/}

        {editing && (
          <div className={styles.transcriptEdit}>
            <textarea
              value={editedTranscript}
              onChange={(e) => setEditedTranscript(e.target.value)}
              rows={3}
            />
            <div className={styles.editActions}>
              <Button onClick={handleTranscriptSubmit}>Save</Button>
              <Button onClick={() => setEditing(false)}>Cancel</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
